<template>
  <v-card :loading="isLoading">
    <v-card-title>
      {{ $t('QlikApp.Form.title') }}
    </v-card-title>
    
    <v-card-text>
      <v-container v-if="internalApp">
        <v-row>
          <v-col cols="12">
            <v-text-field v-model="internalApp.name" :label="$t('QlikApp.Form.alias')"></v-text-field>
          </v-col>
          <v-col cols="6">
            <IconSelector v-model="internalApp.icon" />
          </v-col>
          <v-col cols="6">
            <ColorSelector 
              v-model="internalApp.color"
              @reset="internalApp.color = $vuetify.theme.themes.light.primary" 
              :label="$t('QlikApp.Form.color')" 
            />
          </v-col>
          <v-col cols="12">
            <QlikDimensionsSelector v-model="internalApp.filters" :qAppId="app.qAppId"/>
          </v-col>
          <v-col cols="12">
            <GroupSelector :groups.sync="internalApp.groups" outline/>
          </v-col>
          <v-col cols="4">
            <v-switch :label="internalApp.isEnabled ? $t('Global.Common.enabled') : $t('Global.Common.disabled')" v-model="internalApp.isEnabled"></v-switch>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('cancel')">{{$t('Global.Action.cancel')}}</v-btn>
      <v-btn color="primary" text @click="$emit('confirm', internalApp)">{{$t('Global.Action.confirm')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import GroupSelector from '@/components/Utils/GroupSelector'
import IconSelector from '@/components/Utils/IconSelector'
import ColorSelector from '@/components/Utils/ColorSelector'
import QlikDimensionsSelector from '@/components/Qlik/QlikDimensionsSelector'

export default {
  name: 'AppEditor',
  components: { GroupSelector, IconSelector, ColorSelector, QlikDimensionsSelector },
  props: {
    app: { type: Object },
    isLoading: {type: Boolean, required: false, default: false}
  },
  data: () => ({
    internalApp: null
  }),
  watch: {
    app: {
      immediate: true,
      handler: function (value) {
        this.internalApp = value ? {...value} : null
      }
    }
  }
}
</script>